<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="vl-toolbar">
          <input class="vl-input" type="search" placeholder="Cari nama, nomor pembayaran, atau doa&hellip;"
                 aria-label="Cari sahamqu" [value]="isKeyword"
                 (input)="onKeywordInput($event.target.value)" (keyup.enter)="applyFilter()">
          <select class="vl-select" aria-label="Filter status"
                  (change)="isStatus = $event.target.value; applyFilter()">
            <option value="">Semua status</option>
            <option value="settlement">Berhasil</option>
            <option value="pending">Menunggu</option>
            <option value="failed">Gagal</option>
            <option value="expire">Kedaluwarsa</option>
          </select>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="vl-card">
              <div class="vl-loading" *ngIf="isTableLoading">
                <img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data">
              </div>
              <div class="vl-scroll">
              <table class="vl-table">
                <thead>
                <tr>
                  <th class="vl-num">No</th>
                  <th>Pengguna</th>
                  <th class="text-right">Nominal</th>
                  <th>Metode</th>
                  <th>Nomor Pembayaran</th>
                  <th>Status</th>
                  <th>Doa</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let v of isData; let i = index" class="vl-row" [class.vl-alt]="i % 2 == 1">
                  <th class="vl-num">{{rowNo(i)}}</th>
                  <td>
                    <span class="vl-name" [innerHTML]="highlight(v.userName)"></span>
                    <span *ngIf="v.is_anonymous" class="vl-tag neutral vs-anon" title="Ditampilkan sebagai anonim di aplikasi">
                      <i class="fa fa-user-secret"></i> Anonim</span>
                  </td>
                  <td class="text-right">{{v.nominalVw}}</td>
                  <td>
                    <span *ngIf="v.payment" class="vl-tag neutral">
                      <i *ngIf="v.payment.icon" [ngClass]="v.payment.icon" [style.color]="v.payment.color"></i>
                      {{v.payment.label}}</span>
                    <span *ngIf="!v.payment" class="vl-muted">&mdash;</span>
                  </td>
                  <td>
                    <span *ngIf="v.payment_number" class="vl-code-wrap">
                      <code class="vl-code" [innerHTML]="highlight(v.payment_number)"></code>
                    </span>
                    <span *ngIf="!v.payment_number" class="vl-muted">&mdash;</span>
                  </td>
                  <td>
                    <span *ngIf="v.status == 'settlement'" class="vl-pill on"><span class="vl-dot"></span>Berhasil</span>
                    <span *ngIf="v.status == 'pending'" class="vl-pill wait"><span class="vl-dot"></span>Menunggu</span>
                    <span *ngIf="v.status == 'failed'" class="vl-pill ban"><span class="vl-dot"></span>Gagal</span>
                    <span *ngIf="v.status == 'expire'" class="vl-pill off"><span class="vl-dot"></span>Kedaluwarsa</span>
                  </td>
                  <td class="vs-pray">
                    <span *ngIf="v.pray" class="vs-pray-text" [class.open]="v.showFull" [innerHTML]="highlight(v.pray)"></span>
                    <button type="button" class="vf-more" *ngIf="v.pray && v.pray.length > 120"
                            (click)="v.showFull = !v.showFull">
                      {{v.showFull ? 'Sembunyikan' : 'Selengkapnya'}}</button>
                    <span *ngIf="!v.pray" class="vl-muted">&mdash;</span>
                  </td>
                </tr>
                <tr *ngIf="!isData.length">
                  <td colspan="7" class="vl-empty">Tidak ada data</td>
                </tr>
                </tbody>
              </table><!--end /table-->
              </div>
              <div class="vl-foot">
                <span class="vl-summary">Menampilkan <b>{{formatNumber(summaryFrom())}}&ndash;{{formatNumber(summaryTo())}}</b> dari <b>{{formatNumber(isTotalAll)}}</b> transaksi</span>
                <div class="vl-spacer"></div>
                <nav class="vl-pager" aria-label="Navigasi halaman">
                  <button type="button" class="vl-page" [disabled]="isPage == 1" (click)="goToPage(isPage - 1)">&lsaquo;</button>
                  <ng-container *ngFor="let p of isPages">
                    <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
                    <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == isPage"
                            (click)="goToPage(p)">{{p}}</button>
                  </ng-container>
                  <button type="button" class="vl-page" [disabled]="isPage == totalPages()" (click)="goToPage(isPage + 1)">&rsaquo;</button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
